import ScoreIcon from "components/widgets/ScoreIcon"
import ScoreValue from "components/widgets/ScoreValue"
import PropTypes from "prop-types"
import React from "react"
import "stylesheets/ScorePage/ScoreWidget.scss"
import classNames from "classnames"
import { PILLARS } from "utils/constants/pillars"
import TrendBadge from "views/atoms/badges/TrendBadge"

const ScoreWidget = ({
  maturity,
  hasIcon = true,
  isCentered = true,
  pillarId,
  trendBadge,
  isNewDomain = false
}) => {
  return (
    <div
      id="score"
      className={classNames(pillarId, `Verdikt-ScoreWidget`, {
        centered: isCentered,
        'with-trend-badge': trendBadge || isNewDomain
      })}
    >
      <div className="score-value-container">
        <ScoreValue score={maturity} pillarId={pillarId} />
      </div>

      <div className="badge-container">
        {hasIcon && (
          <div className="icon-wrapper">
            <ScoreIcon score={maturity} pillarId={pillarId} />
          </div>
        )}
        
        {(trendBadge || isNewDomain) && (
          <div className="trend-badge-wrapper">
            {isNewDomain ? (
              <TrendBadge
                isNew={true}
                size="small"
                variant="score"
              />
            ) : (
              <TrendBadge
                trendBadge={trendBadge}
                size="small"
                variant="score"
                color="auto-inverse"
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

ScoreWidget.propTypes = {
  hasIcon: PropTypes.bool,
  isCentered: PropTypes.bool,
  maturity: PropTypes.number.isRequired,
  pillarId: PropTypes.oneOf(PILLARS),
  trendBadge: PropTypes.object,
  isNewDomain: PropTypes.bool
}

ScoreWidget.defaultProps = {
  trendBadge: null,
  isNewDomain: false
}

export default ScoreWidget